// DS: C115
import React, { useEffect } from 'react';
import { useDismissableNotification } from '../Notifications/Notification/useDismissableNotification';
import { NotificationQueueItem } from '../Notifications/redux/types';
import LiveNotificationCard from './_partials/LiveNotificationCard';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import {
  BiContextProvidedValue,
  BiData,
  ItemClickBiEvent,
  LiveNotificationViewBiEvent,
} from '@wix/da-bi/pkg/events';
import DOMPurify from 'isomorphic-dompurify';

import liveNotificationsStyle from './LiveNotifications.scss';

interface Props extends NotificationQueueItem {
  notificationHtml: string;
  linkTo?: string;
  biData: {
    notification_type: string;
    notification_sender_id: string;
    typeid: number;
    itemid: number;
  };
}

const LiveNotification: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  queueName,
  notificationHtml,
  linkTo,
  biData,
}) => {
  const logBiEvent = useBiLogger();

  const { onClose, onPause, onUnpause } = useDismissableNotification({
    id,
    queueName,
    duration: 10000,
  });

  useEffect(() => {
    logBiEvent(
      BiData<LiveNotificationViewBiEvent>({
        evid: 656,
        ...biData,
      })
    );
  }, [logBiEvent, biData]);

  return (
    <LiveNotificationCard
      onClose={onClose}
      onMouseEnter={onPause}
      onMouseLeave={onUnpause}
      biData={biData}
    >
      {linkTo ? (
        <BiLink
          href={linkTo}
          className={liveNotificationsStyle['notification-link']}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(notificationHtml),
          }}
          biData={BiData<ItemClickBiEvent>({
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            evid: 100,
            ...biData,
          })}
        />
      ) : (
        <BiSpan
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(notificationHtml),
          }}
          biData={BiData<ItemClickBiEvent>({
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            evid: 100,
            ...biData,
          })}
        />
      )}
    </LiveNotificationCard>
  );
};

LiveNotification.displayName = 'LiveNotification';

export default LiveNotification;
